import {
    Component, Mixins,
} from 'vue-property-decorator';
import CoreMixin from '@nodes/mixins/Core';
import { digits, separated, percent } from '@nodes/helpers/number';
import {
    YPanel, YTable, YEmpty, YImage, YBadge, YModal,
} from '@components/index';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

interface ModalRef extends Vue {
    open(): void;
    close(): void;
}

@Component({
    components: {
        YPanel,
        YTable,
        YEmpty,
        YImage,
        YBadge,
        YModal,
    },
})

/**
 * @name ProfileWishlist
 */
export default class ProfileWishlist extends Mixins(CoreMixin, HybridMixin, Props) {
    /**
     * Refs types
     */
    $refs!: {
        removeModal: ModalRef;
    };
    
    digits = digits;
    separated = separated;
    percent = percent;

    items = null;
    removeWare = null;

    tableHeader = [
        {
            id   : 'title',
            title: this.$t('dashboard.wishlist.table.title'),
        },
        {
            id   : 'price',
            title: this.$t('dashboard.wishlist.table.price'),
        },
    ];

    /**
     * @inheritdoc
     */
    created() {
        this.fetchWishlist();
    }

    /**
     * Fetch Wishlist
     * 
     * @returns {*}
     */
    fetchWishlist(): any {
        this.$wait.start('fetch-wishlist');
        const params = {
            model    : 'content-post',
            order    : 'desc',
            including: ['image', 'url_encode', 'title', 'ware_has_discount', 'ware_original_price', 'ware_sale_price', 'wares'],
        };
        return this.$services[this.favouritesListService.name][this.favouritesListService.api](params).then((response) => {
            this.items = response.data.results;
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('fetch-wishlist');
        });
    }
    
    /**
     * Open modal.
     *
     * @param {string} id - select item
     */
    openModal(id) {
        this.removeWare = id;
        this.$refs.removeModal.open();
    }

    /**
     * Close modal.
     */
    closeModal() {
        this.$refs.removeModal.close();
    }

    /**
     * Remove Item from Wishlist
     *
     * @param {string} id
     * @returns {*}
     */
    removeItem(id: string): any {
        this.$wait.start(`remove-from-wishlist-${id}`);
        const params = {
            id,
            model : 'content-post',
            status: 0,
        };
        return this.$services[this.removeItemService.name][this.removeItemService.api](params).then(() => {
            this.$toast.success(this.$t('dashboard.wishlist.delete_msg'));
            this.closeModal();
            this.fetchWishlist();
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end(`remove-from-wishlist-${id}`);
        });
    }

    /**
     * Product Link
     *
     * @param {string} urlEncode
     * @returns {object}
     */
    productRoute(urlEncode: string): object {
        return {
            name  : this.getValue('productSingleRoute').name,
            params: {
                url_encode: urlEncode,
            },
        };
    }
}
